import React from "react";
import Entity from "../../components/Entity";
import { STATUS, FORMATS } from "../../Constants";
import ProductPriceCodes from "../../components/ProductPriceCodes";

function Product() {
  return (
    <Entity
      title={(e) => e.description || "New Product"}
      formShema={{
        fields: [
          { name: "Description (EN)", propertyName: "description", type: "input", col: 12 },
          { name: "Description (FR)", propertyName: "descriptionFr", type: "input", col: 12 },
          { name: "Status",        propertyName: "status",       type: "select", options: STATUS,           isMulti: false, col: 3 },
          { name: "Product Type",  propertyName: "productType",  type: "select", optionsFromServer: "productTypes", isMulti: false, col: 3 },
          { name: "Brand",         propertyName: "make",         type: "input",  col: 3 },
          { name: "UPC Code",      propertyName: "upcCode",      type: "input",  col: 3 },
          { name: "Principal",     propertyName: "manufacturer", type: "select", optionsFromServer: "manufacturers", isMulti: false, col: 4 },
          { name: "Size",          propertyName: "formatQut",    type: "input",  col: 2 },
          { name: "Format",        propertyName: "format",       type: "select", options: FORMATS,          isMulti: false, col: 2 },
          { name: "Pricing",       propertyName: "priceType",    type: "select", optionsFromServer: "priceTypes", isMulti: false, col: 4 },
        ],
      }}
    >
      <ProductPriceCodes />
    </Entity>
  );
}

export default Product;
